export default __webpack_public_path__ + "static/media/ozempic-inject-allsteps-waist.7127ccdf.mp4";